import React from "react";
import { Dropdown, Button, Form, Image } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Search, ThreeDotsVertical, XLg } from "react-bootstrap-icons";
import Card from "react-bootstrap/Card";
import { useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import dashboardIcon from "../../assets/svg/dashboardIcon.svg";
import {
  fetchDashboardList,
  fetchDashboardChart,
} from "../../store/actions/dashboardsAction";
import { fetchLocationList } from "../../store/actions/locationsAction";
import { useDispatch, useSelector } from "react-redux";
import dash1 from "../../assets/images/dash1.png";
import dash2 from "../../assets/images/dash2.png";
import dash3 from "../../assets/images/dash3.png";
import dash4 from "../../assets/images/dash4.png";
import dash5 from "../../assets/images/dash5.png";
import dash6 from "../../assets/images/dash6.png";
import dash7 from "../../assets/images/dash7.png";
import dash8 from "../../assets/images/dash8.png";
import dashboard from "../../assets/images/dashboard.png";
import moment from "moment";
import Loader from "../common/loader/Loader";
import ApiResponsePopup from "../common/modal/ApiResponsePopup";
import { Line, Bar } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { Chart as ChartJS } from "chart.js/auto";
export default function DashboardCard() {
  const navigate = useNavigate();
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;

  const isOnlyIMCStroke =
    Array.isArray(adminDetail?.wardTypes) &&
    adminDetail.wardTypes.length === 1 &&
    adminDetail.wardTypes[0] === "IMC-STROKE";

  useEffect(() => {
    if (adminDetail) {
      if (adminDetail?.isWardSystemAccessible) {
        navigate("/");
      } else if(isOnlyIMCStroke){
        navigate("/imc");
      } else {
        navigate("/manage-client");
      }
    }
  }, [adminDetail]);

  var todayDate = new Date().toISOString().slice(0, 7);
  const formatedDate = (val) => {
    let dt = new Date(val);
    return <span>{moment(dt).format("lll")}</span>;
  };

  const dispatch = useDispatch();
  const {
    dashboards,
    filtered,
    isLoader,
    isRecordUpdated,
    error: apiError,
    dashboardChart,
  } = useSelector((state) => {
    return state.dashboards;
  });
  const { locations } = useSelector((state) => {
    return state.locations;
  });
  
  const cc = filtered || dashboards;
  const [isShow, setIsShow] = useState(false);
  const [isGraphparam, setGraphparam] = useState(false);
  const [locationOptions, setLocationOptions] = useState(null);
  const [selectedWardType, setSelectedWardType] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [datefield, setDatefield] = useState(null);
  const [changeColor, setChangeColor] = useState(null);
  const [label, setLabel] = useState(null);
  const [fieldvalue, setfieldvalue] = useState("AvailableBeds");
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        fill: true,
        backgroundColor: changeColor,
        borderColor: "#fff",
      },
    ],
  });
  const options = {
    showTooltips: true,
    maintainAspectRatio: false,
    responsive: true,
    // hoverMode: "index",
    plugins: {
      indexAxis: "x",
      // tooltip: {
      //   mode : "x",

      // },
      interaction: {
        mode: "index",
        axis: "x",
        intersect: false,
      },
      tooltip: {
        yAlign: "top",
        enabled: true,
        mode: "nearest",
        position: "average",
        intersect: false,
      },
      hover: {
        mode: "index",
        intersect: false,
      },
    },
    // tooltips: {
    //   mode: "x",
    //   position: "average",
    // },

    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          // hide decimal values
          precision: 0,
        },
      },
    },
  };
  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
    setDatefield(moment().format("YYYY-MM"));
    // setEndDate(moment().format("YYYY-MM-DD"));
  }, []);

  useEffect(() => {
    // color
    if (dashboardChart?.filter == "TotalVirtualBeds") {
      setChangeColor("#22BEA0");
      setLabel("Total ward capacity");
    } else if (dashboardChart?.filter == "CurrentOccupiedBeds") {
      setChangeColor("#5464F8");
      setLabel("Current Occupied Beds");
    } else if (dashboardChart?.filter == "AvailableBeds") {
      setChangeColor("#71C1E8");
      setLabel("Number of beds available");
    } else if (dashboardChart?.filter == "TomorrowPendingDischarge") {
      setChangeColor("#E89416");
      setLabel("Tomorrow Pending Discharge");
    } else if (dashboardChart?.filter == "TodayConfirmedDischarge") {
      setChangeColor("#FF3D62");
      setLabel("Today Confirmed Discharge");
    } else if (dashboardChart?.filter == "TotalDelays") {
      setChangeColor("#31638F");
      setLabel("Total Delays");
    } else if (dashboardChart?.filter == "TotalStepUpBeds") {
      setChangeColor("#855DDB");
      setLabel("Total StepUp Beds");
    } else if (dashboardChart?.filter == "TotalStepDownBeds") {
      setChangeColor("#855DDB");
      setLabel("Total StepDown Beds");
    }
    let label = [];
    let localdata = [];
    for (let i = 0; i < dashboardChart?.resultArray?.length; i++) {
      let keys = Object.keys(dashboardChart?.resultArray[i]);
      if (keys[0]) {
        label.push(keys[0]);
        localdata.push(dashboardChart?.resultArray[i][keys[0]]);
      }
    }
    setGraphData({
      labels: label,
      datasets: [
        {
          label: fieldvalue,
          data: localdata,
          fill: true,
          backgroundColor: "#6A4AAE",
          borderColor: "#6A4AAE",
          borderWidth: "2px",
          // barThickness: 8,
          maxBarThickness: 10,
          minBarLength: 2,
          responsive: true,
        },
      ],
    });

 
  }, [dashboardChart]);

  useEffect(() => {
   
    dispatch(
      fetchDashboardList({
        location: selectedLocation,
        wardType: selectedWardType,
      })
    ).then(({ payload }) => {
      if (payload.success) {
        hideHandlerRes();
      } else {
        setIsShow(true);
      }
    });
  }, [selectedLocation, selectedWardType]);

  useEffect(() => {
    if (Array.isArray(locations)) {
      // let arr = locations.map((x) => x.name);
      setLocationOptions(locations);
    }
  }, [locations]);

  const hideHandlerRes = () => {
    setIsShow(false);
  };
  useEffect(() => {
    if (datefield) {
      var monthData = datefield;
      const myArray = monthData.split("-");
      if (myArray[1] == "01") {
        setMonth("0");
      } else {
        setMonth(parseInt(myArray[1] - 1));
      }

      setYear(myArray[0]);
     
    }
  }, [datefield]);

  useEffect(() => {
    const hasValidYear = year !== null && year !== undefined && year !== "";
    const hasValidMonth = month !== null && month !== undefined && month !== "";

    if (hasValidYear && hasValidMonth && fieldvalue) {
      setGraphparam(true);
    } else {
      setGraphparam(false);
    }
  }, [year, month, fieldvalue, selectedLocation, selectedWardType]);

  useEffect(() => {
    if (!isGraphparam) {
      return;
    }

    let formData = {
      year: year,
      month: month,
      fieldvalue: fieldvalue,
      location: selectedLocation,
      wardType: selectedWardType,
    };

    dispatch(fetchDashboardChart(formData)).then(({ payload }) => {
      if (payload.success) {
      } else {
        setIsShow(true);
      }
    });

    setGraphparam(false);
  }, [isGraphparam]);

  return (
    <div className="container">
      {/* title */}
      <h1 className="main-title">Dashboard</h1>
      {/* filter section */}
      {isLoader && <Loader />}
      {adminDetail?.isWardSystemAccessible && 
      <>
       {dashboards ? (
        <section>
          <div className="block-detail">
            <div className="d-md-flex" style={{ float: "right" }}>
              <Form.Select
                style={{ color: "gray" }}
                className="searchBox"
                aria-label="Select Geography"
                placeholder="Select Geography"
                value={selectedLocation}
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                }}
              >
                <option
                  className="optionDefault"
                  selected
                  value=""
                  onClick={(e) => {
                    setSelectedLocation("");
                  }}
                >
                  All (Geography)
                </option>
                {locationOptions
                  ? locationOptions.map((item) => (
                      <option style={{ color: "black" }} value={item?._id}>
                        {item.name}
                      </option>
                    ))
                  : ""}
              </Form.Select>
              <Form.Select
                style={{ color: "gray" }}
                className="selectForm selectForm2"
                aria-label="Select Ward Type"
                value={selectedWardType}
                onChange={(e) => {
                  setSelectedWardType(e.target.value);
                }}
              >
                <option
                  className="objKey optionDefault"
                  value=""
                  onClick={(e) => {
                    setSelectedWardType("");
                  }}
                >
                  All (Ward Type)
                </option>
                <option value="Frailty Virtual">Frailty Virtual</option>
                <option value="Respiratory Virtual">Respiratory Virtual</option>
                <option value="Physical Ward">Physical Ward</option>
                <option value="Heart Failure Virtual">
                  Heart Failure Virtual
                </option>
                {/* <option value="IMC">IMC</option> */}
              </Form.Select>
              <span
                className="clearBtn"
                onClick={(e) => {
                  setSelectedWardType("");
                  setSelectedLocation("");
                }}
              >
                Clear All
              </span>
            </div>
          </div>
          {/* paragraph */}
          <div className="block">
            {/* <p className="das-para">
              Last Updated at{" "}
              <span>{formatedDate(dashboards?.createdAt)} </span>
            </p> */}
          </div>
          {/* card section start */}

          <Row xs={1} md={4} className="g-3 dashboard-card">
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.availableBeds}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash1}
                    />
                  </div>

                  <Card.Text>
                    Number Of Beds
                    <br /> Available
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.currentlyOccupiedbeds}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash2}
                    />
                  </div>

                  <Card.Text>Current Occupied Beds</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{
                        fontWeight: "600",
                        fontSize: "24px",
                        marginLeft: "-8px",
                      }}
                    >
                      {dashboards?.totalVirtualBeds}
                    </Card.Title>

                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash3}
                    />
                  </div>
                  <Card.Text>Total Ward Capacity</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.totalDischargesYesterday}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash4}
                    />
                  </div>
                  <Card.Text>
                    Total Discharges <br />
                    Yesterday
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            {/* Row-2 */}
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.totalAdmissionsYesterday}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash5}
                    />
                  </div>
                  <Card.Text>
                    Total Admissions
                    <br />
                    Yesterday
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.todayDelays}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash6}
                    />
                  </div>
                  <Card.Text>
                    Total Delays <br />
                    (over 24 hours)
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.totalStepUpBeds}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash7}
                    />
                  </div>
                  <Card.Text>Total Step Up Beds</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="cardBox">
                  <div className="ms-2 d-flex justify-content-between">
                    <Card.Title
                      style={{ fontWeight: "600", marginLeft: "-8px" }}
                    >
                      {dashboards?.totalStepDownBeds}
                    </Card.Title>
                    <Card.Img
                      style={{ marginTop: "-16px" }}
                      variant="right"
                      className="p-2"
                      src={dash8}
                    />
                  </div>
                  <Card.Text>Total Step Down Beds</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row xs={1} md={4} className="g-3 dashboard-card mt-1">
            <Col md={12}>
              <div
                className="chartBg"
                style={{ background: "#fff", padding: "4px" }}
              >
                <div className="block">
                  <span className="das-para ms-2">Analytics</span>
                  <span className="dateData">
                    {moment(dashboardChart?.startDate).format("DD/MM/YYYY")} -{" "}
                    {moment(dashboardChart?.endDate).format("DD/MM/YYYY")}
                  </span>
                  <div
                    className="filterChartValue d-md-flex mt-2"
                    style={{ float: "right" }}
                  >
                    <Form.Select
                      className="select-form me-2"
                      placeholder="Select Items"
                      value={fieldvalue}
                      onChange={(e) => {
                        setfieldvalue(e.target.value);
                      }}
                    >
                      <option value="AvailableBeds">
                        Number Of Beds Available
                      </option>

                      <option value="CurrentOccupiedBeds">
                        Current Occupied Beds
                      </option>
                      <option value="TotalVirtualBeds">
                        Total Ward Capacity
                      </option>
                      <option value="totalAdmissionsYesterday">
                        Total Admissions Yesterday
                      </option>
                      <option value="totalDischargesYesterday">
                        Total Discharges Yesterday
                      </option>
                      <option value="TotalDelays">Total Delays</option>
                      <option value="TotalStepUpBeds">
                        Total Step Up Beds
                      </option>
                      <option value="TotalStepDownBeds">
                        Total Step Down Beds
                      </option>
                    </Form.Select>

                    <Form.Control
                      className="select-date py-2 "
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                      type="month"
                      placeholder="Select"
                      column={6}
                      name="month"
                      max={todayDate}
                      defaultValue={datefield}
                      onChange={(e) => {
                        setDatefield(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div
                  className="chartSection"
                  style={{ height: "400px", width: "98%" }}
                >
                  <p className="chartLabel">{label}</p>
                  <div className="whiteArea">&nbsp;</div>
                  <Bar
                    data={graphData}
                    options={options}
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {moment(dashboardChart?.endDate).format("MMMM YYYY")}
                </p>
                {/* <Row md={2} >
                  <Col md={2}><p className="chartLabel">Virtual Beds</p></Col>
                  <Col md={10}><Bar data={graphData}  /></Col>
                </Row> */}
              </div>
            </Col>
          </Row>
        </section>
      ) : (
        <>
          {!isLoader && (
            <center>
              <img src={dashboard} alt="img" />
            </center>
          )}
        </>
      )}
      </>
      }
     
      {/* <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordUpdated: isShow,
          title: "Error",
          successMsg: "data loaded successfully!!",
          errorRes: apiError?.message,
        }}
      /> */}
    </div>
  );
}
